import { render, staticRenderFns } from "./pi-radio.vue?vue&type=template&id=847a8fc2&"
import script from "./pi-radio.vue?vue&type=script&lang=ts&"
export * from "./pi-radio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports